<template>
  <div>
    <OtherHeaderComponent />
    <div class="how-to-play-container">
      <div class="section">
        <h2 class="section-title">
          <span class="title-underline">{{ getTranslatedText("Select your draw") }}</span>
        </h2>
        <div class="section-content">
          <img
            src="@/public/images/play-games.png"
            alt="Play Games Example"
            class="betslip-image"
          />
          <p class="description" v-html="getTranslatedText('Select any of the live draws by clicking &quot;<b>Play</b>&quot;. Draws take place throughout the day, giving you chances to win all week.')"></p>
        </div>
      </div>

      <div class="section">
        <h2 class="section-title">
          <span class="title-underline" v-html="getTranslatedText('Choose your market and winning number/s')"></span>
        </h2>
        <div class="section-content">
          <img
            src="@/public/images/preferred-market.png"
            alt="Preferred Market Example"
            class="betslip-image"
          />
          <p class="description" v-html="getTranslatedText('Choose your preferred market from the list available by selecting your <b>ball(s)</b>/<b>number(s)</b> you wish to play. This automatically registers the market type you are playing. You can improve your odds by choosing to predict the most numbers possible in each market type. You can also bet on the outcome of the bonus ball in some draws.')"></p>
        </div>
      </div>

      <div class="section">
        <h2 class="section-title">
          <span class="title-underline">{{ getTranslatedText("Submit your bet") }}</span>
        </h2>
        <div class="section-content">
          <img
            src="@/public/images/bet-placed.png"
            alt="Bet Placed Example"
            class="betslip-image"
          />
          <div>
            <p class="description" v-html="getTranslatedText('Once you have selected your market and number(s), select <b>&quot;Add&quot;</b> to add this selection to your <b>betslip</b>. This will show your betslip at the bottom of the page for you to click on when you want to add your stake value. It is referenced as <b>&quot;Your bet&quot;</b> with the number of bets pending shown next to this.')"></p>
            <p class="description" v-html="getTranslatedText('Once this bet bar has been clicked on, your bet slip will open up. Enter the amount of money you would like to bet with and submit your bet by clicking on <b>&quot;Add to betslip&quot;</b>.')"></p>
            <p class="description" v-html="getTranslatedText('<b>Your wager history</b> will display all your wagers and winnings in the tabs named <b>&quot;My Bets&quot;</b> and <b>&quot;Payouts&quot;</b>. Also, all the draw results are displayed for your convenience!')"></p>
          </div>
        </div>
      </div>

      <div style="padding: 10px; margin-bottom: 50px;">
        <HomeFooterButton />
      </div>
    </div>
  </div>
</template>


<script>
import HomeFooterButton from "@/components/common/HomeFooterButton.vue";
import OtherHeaderComponent from "@/components/common/OtherHeaderComponent.vue";
import languageMixins from "@/mixins/language-mixins";
export default {
  name: "HowToPlay",
  mixins: [languageMixins],
  components: { HomeFooterButton, OtherHeaderComponent },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.how-to-play-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  font-family: "Arial", sans-serif;
}

.section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 15px;
  position: relative;
}

.title-underline {
  display: inline-block;
  padding-bottom: 5px;
  position: relative;
}

.title-underline::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 200px;
  height: 3px;
  background-color: #0000ff;
}

.section-content {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: nowrap;
}

.description {
  font-size: 15px;
  line-height: 1.6;
  color: #333;
  max-width: 600px;
  margin-bottom: 10px;
}

.betslip-image {
  max-width: 300px;
  height: auto;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  object-fit: contain;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .section-content {
    flex-wrap: wrap;
    justify-content: center;
  }

  .betslip-image {
    max-width: 100%;
    margin-bottom: 10px;
  }

  .description {
    max-width: 100%;
  }
}
</style>
